import React from 'react';
import Toast from './Toast';
import {useReplayControls} from '../../contexts/ReplayControlsContext';
import {TOASTS_HIDDEN_FROM_SPEED_MULTIPLIER} from '../../configs/playbackSpeed';

/**
 * Тост матча вместе с правилом «когда его не показывать».
 *
 * Зритель тосты видит: они рассказывают о том, что происходит в партии
 * (сработавшая ловушка, чужой переброс, отказ действия), и наблюдающему они
 * не менее интересны, чем игроку — раньше тост зрителю не показывался вовсе.
 *
 * Исключение — быстрая перемотка записи: с TOASTS_HIDDEN_FROM_SPEED_MULTIPLIER
 * сообщения сменяются быстрее, чем их можно прочитать, и только мешают
 * смотреть. Скорость живет в контексте просмотра (ReplayControlsContext), вне
 * записи она всегда 1, поэтому отдельной проверки на режим не нужно
 */
const GameToast = () => {
  const {speedMultiplier} = useReplayControls();

  if (speedMultiplier >= TOASTS_HIDDEN_FROM_SPEED_MULTIPLIER) {
    return null;
  }

  return <Toast/>;
};

export default GameToast;
